module.exports = class CoachmarkModel extends Backbone.Model
